<template>
  <div>
    <i :title="invoicing.title" :class="invoicing.icon"></i>&nbsp;
    <i :title="shipping.title" :class="shipping.icon"></i>&nbsp;
    <i :title="delivery.title" :class="delivery.icon"></i>
  </div>
</template>

<script>
export default {
  props: [
    "invoicing_accepted",
    "shipping_accepted",
    "delivery_accepted",
    "status",
  ],
  data() {
    return {
      invoicing: {
        icon: "fa fa-money btn-edit",
        title: "Ainda não foi faturado lá no marketplace",
      },
      shipping: {
        icon: "fas fa-shipping-fast btn-edit",
        title: "Ainda não despachou o pedido",
      },
      delivery: {
        icon: "fas fa-people-carry btn-edit",
        title: "Ainda não foi entregue ao cliente",
      },
    };
  },
  methods: {
    invoicingAccepted() {
      if (
        this.invoicing_accepted ||
        this.status === "delivered" ||
        this.status === "invoiced" ||
        this.status === "shipped"
      ) {
        this.invoicing.icon = "fa fa-money text-green";
        this.invoicing.title = "Já foi faturado lá no marketplace";
      }
    },
    shippingAccepted() {
      if (
        this.shipping_accepted ||
        this.status === "delivered" ||
        this.status === "shipped"
      ) {
        this.shipping.icon = "fas fa-shipping-fast text-green";
        this.shipping.title =
          "Já despachou o pedido, marketplace confirmou o recebimento do status";
      }
    },
    deliveryAccepted() {
      if (this.delivery_accepted || this.status === "delivered") {
        this.delivery.icon = "fas fa-people-carry text-green";
        this.delivery.title = "Já foi entregue ao cliente";
      }
    },
  },
  beforeMount() {
    this.invoicingAccepted();
    this.shippingAccepted();
    this.deliveryAccepted();
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/WhenTheOrderIs.vue